import { render, staticRenderFns } from "./ModalNdviDiff.vue?vue&type=template&id=680a9af8&scoped=true"
import script from "./ModalNdviDiff.vue?vue&type=script&lang=ts"
export * from "./ModalNdviDiff.vue?vue&type=script&lang=ts"
import style0 from "./ModalNdviDiff.vue?vue&type=style&index=0&id=680a9af8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680a9af8",
  null
  
)

export default component.exports